var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02IconoRecomendaciones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 157.832,
    height: 137.611,
    viewBox: "0 0 157.832 137.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.762,
    y1: 5.485,
    x2: -1.758,
    y2: 5.484,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f8f0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e7e8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dce3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d5e0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#d3dff2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "etapas",
    transform: "translate(1 2.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 66.306,
    cy: 66.306,
    r: 66.306,
    transform: "translate(21.721)",
    fill: "none",
    stroke: "#f0f4f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    strokeDasharray: "1 12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 44.585)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    "data-name": "Oval",
    cx: 21.721,
    cy: 21.721,
    r: 21.721,
    fill: "#fdfffc",
    stroke: "#f0f4f9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M7.434,13.718a1.43,1.43,0,0,1-1.1-.473L.447,7.2A1.524,1.524,0,0,1,.5,5a1.524,1.524,0,0,1,2.206.052L7.487,9.988,17.574.427a1.561,1.561,0,1,1,2.154,2.259L8.538,13.3A1.806,1.806,0,0,1,7.434,13.718Z",
    transform: "translate(11.432 14.862)",
    fill: "#7821a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_83",
    "data-name": "Grupo 83",
    transform: "translate(-74.542 10.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(128.008 20.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_034---Social-Media-Responces",
    "data-name": "034---Social-Media-Responces"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color_copy",
    "data-name": "color copy",
    transform: "translate(1.192 1.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M200.3,155.437v5.958a3.574,3.574,0,0,1-3.574,3.575H163.362a3.574,3.574,0,0,1-3.574-3.575v-5.958a3.574,3.574,0,0,0,3.574,3.575h33.361A3.574,3.574,0,0,0,200.3,155.437Z",
    transform: "translate(-146.682 -95.864)",
    fill: "#a4c2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M237.514,159.012v2.383a3.574,3.574,0,0,1-3.575,3.575h3.575a3.574,3.574,0,0,0,3.574-3.575v-5.958A3.574,3.574,0,0,1,237.514,159.012Z",
    transform: "translate(-187.472 -95.864)",
    fill: "#7facfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M184.809,55.194V74.257a2.39,2.39,0,0,0,2.383,2.383h1.191v4.766l9.532-4.766H200.3V82.6a3.574,3.574,0,0,1-3.574,3.575H163.362a3.574,3.574,0,0,1-3.574-3.575V56.385h2.383l9.532,4.766V56.385h1.192A2.39,2.39,0,0,0,175.277,54V34.938a2.39,2.39,0,0,0-2.383-2.383H159.788V26.6a3.574,3.574,0,0,1,3.574-3.574h4.766l3.408,3.634a3.561,3.561,0,0,0,2.609,1.132h11.8a3.562,3.562,0,0,0,2.609-1.132l3.408-3.634h4.766A3.574,3.574,0,0,1,200.3,26.6V52.811H187.192A2.39,2.39,0,0,0,184.809,55.194Z",
    transform: "translate(-146.682 -23.024)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_79",
    "data-name": "Grupo 79",
    transform: "translate(34.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M213.414,89.23H209.84a2.39,2.39,0,0,0-2.383,2.383v19.063a2.39,2.39,0,0,0,2.383,2.383h1.191v4.766l3.574-1.787V113.06h-1.191a2.39,2.39,0,0,1-2.383-2.383V91.613A2.39,2.39,0,0,1,213.414,89.23Z",
    transform: "translate(-207.457 -59.443)",
    fill: "#cad9fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M237.514,23.024h-3.575a3.574,3.574,0,0,1,3.575,3.574V52.811h3.574V26.6A3.574,3.574,0,0,0,237.514,23.024Z",
    transform: "translate(-222.025 -23.024)",
    fill: "#cad9fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M237.514,142.792v5.362a3.574,3.574,0,0,1-3.575,3.575h3.575a3.574,3.574,0,0,0,3.574-3.575V142.2H238.7Z",
    transform: "translate(-222.025 -88.58)",
    fill: "#cad9fc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M202.155,23.024l-3.408,3.634a3.562,3.562,0,0,1-2.609,1.132h-11.8a3.561,3.561,0,0,1-2.609-1.132l-3.408-3.634Z",
    transform: "translate(-156.879 -23.024)",
    fill: "#a4c2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    d: "M215.989,23.024l-3.408,3.634a3.562,3.562,0,0,1-2.609,1.132h3.575a3.561,3.561,0,0,0,2.609-1.132l3.408-3.634Z",
    transform: "translate(-174.288 -23.024)",
    fill: "#7facfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    d: "M159.252,46.593V65.657a2.39,2.39,0,0,1-2.383,2.383h-1.192v4.766l-9.532-4.766H133.04a2.389,2.389,0,0,1-2.383-2.383V46.593a2.39,2.39,0,0,1,2.383-2.383h23.83A2.39,2.39,0,0,1,159.252,46.593Z",
    transform: "translate(-130.657 -34.678)",
    fill: "#f1eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    "data-name": "Shape",
    d: "M183.091,44.21h-3.575a2.39,2.39,0,0,1,2.383,2.383V65.657a2.39,2.39,0,0,1-2.383,2.383h-1.192v2.979l3.575,1.787V68.039h1.192a2.39,2.39,0,0,0,2.383-2.383V46.593A2.39,2.39,0,0,0,183.091,44.21Z",
    transform: "translate(-156.879 -34.678)",
    fill: "#efd2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-11",
    "data-name": "Shape",
    d: "M244,91.613v19.063a2.39,2.39,0,0,1-2.383,2.383H228.507l-9.532,4.766V113.06h-1.191a2.39,2.39,0,0,1-2.383-2.383V91.613a2.39,2.39,0,0,1,2.383-2.383h23.829A2.39,2.39,0,0,1,244,91.613Z",
    transform: "translate(-177.274 -59.443)",
    fill: "#f1eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-12",
    "data-name": "Shape",
    d: "M269.293,89.23h-3.574a2.39,2.39,0,0,1,2.383,2.383v19.063a2.39,2.39,0,0,1-2.383,2.383h3.574a2.39,2.39,0,0,0,2.383-2.383V91.613A2.39,2.39,0,0,0,269.293,89.23Z",
    transform: "translate(-204.954 -59.443)",
    fill: "#efd2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    width: 4.766,
    height: 9.532,
    rx: 2.383,
    transform: "translate(54.808 38.648)",
    fill: "#efd2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-13",
    "data-name": "Shape",
    d: "M240.823,104.33v7.149h-7.149a2.39,2.39,0,0,1-2.383-2.383v-2.383a2.39,2.39,0,0,1,2.383-2.383h.822l-.751-3a2.383,2.383,0,0,1,4.623-1.156l1.037,4.158Z",
    transform: "translate(-186.015 -64.491)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "color",
    transform: "translate(1.192 1.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-14",
    "data-name": "Shape",
    d: "M163.362,129.345V97.175h-3.574v32.17a3.574,3.574,0,0,0,3.574,3.574h3.575A3.574,3.574,0,0,1,163.362,129.345Z",
    transform: "translate(-146.682 -63.814)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-15",
    "data-name": "Shape",
    d: "M134.231,65.657V46.593a2.39,2.39,0,0,1,2.383-2.383H133.04a2.39,2.39,0,0,0-2.383,2.383V65.657a2.389,2.389,0,0,0,2.383,2.383h3.575A2.39,2.39,0,0,1,134.231,65.657Z",
    transform: "translate(-130.657 -34.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-16",
    "data-name": "Shape",
    d: "M163.362,26.6a3.574,3.574,0,0,1,3.575-3.574h-3.575a3.574,3.574,0,0,0-3.574,3.574v5.958h3.574Z",
    transform: "translate(-146.682 -23.024)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path-2",
    "data-name": "Rectangle-path",
    d: "M128.008,49.506h2.383v9.532h-2.383Z",
    transform: "translate(-128.008 -36.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_80",
    "data-name": "Grupo 80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-17",
    "data-name": "Shape",
    d: "M129.245,59.834a1.192,1.192,0,0,1-.012-2.383h.012a1.192,1.192,0,1,1,0,2.383Z",
    transform: "translate(-128.03 -40.77)",
    fill: "#7821a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-18",
    "data-name": "Shape",
    d: "M193.539,50.162h-9.532V25.141a4.766,4.766,0,0,0-4.766-4.766H145.88a4.766,4.766,0,0,0-4.766,4.766v4.766h-9.532a3.574,3.574,0,0,0-3.575,3.574,1.192,1.192,0,1,0,2.383,0,1.191,1.191,0,0,1,1.191-1.191h23.83a1.192,1.192,0,0,1,1.191,1.191V52.545a1.192,1.192,0,0,1-1.191,1.191H154.22a1.192,1.192,0,0,0-1.191,1.191v2.838l-7.808-3.9a1.2,1.2,0,0,0-.533-.125H131.583a1.191,1.191,0,0,1-1.191-1.191V43.013a1.192,1.192,0,1,0-2.383,0v9.532a3.574,3.574,0,0,0,3.575,3.575h9.532V87.1a4.766,4.766,0,0,0,4.766,4.766h33.361a4.766,4.766,0,0,0,4.766-4.766V76.374h9.532a3.574,3.574,0,0,0,3.575-3.575V53.736A3.574,3.574,0,0,0,193.539,50.162Zm-21.813-27.4-1.527,1.63a2.393,2.393,0,0,1-1.74.753h-11.8a2.383,2.383,0,0,1-1.738-.753l-1.527-1.63Zm7.516,66.722H145.88A2.383,2.383,0,0,1,143.5,87.1V85.244a4.712,4.712,0,0,0,2.383.662h33.361a4.714,4.714,0,0,0,2.383-.662V87.1A2.383,2.383,0,0,1,179.242,89.481Zm2.383-8.34a2.383,2.383,0,0,1-2.383,2.383H145.88A2.383,2.383,0,0,1,143.5,81.14V56.12h.91l9.281,4.647a1.192,1.192,0,0,0,1.724-1.073V56.12a3.574,3.574,0,0,0,3.574-3.575V33.481a3.574,3.574,0,0,0-3.574-3.574H143.5V25.141a2.383,2.383,0,0,1,2.383-2.383h4.25l3.056,3.259a4.778,4.778,0,0,0,3.476,1.507h11.8a4.791,4.791,0,0,0,3.478-1.506l3.055-3.26h4.25a2.383,2.383,0,0,1,2.383,2.383V50.162H169.71a3.574,3.574,0,0,0-3.575,3.575V72.8a3.574,3.574,0,0,0,3.575,3.575v3.575a1.192,1.192,0,0,0,1.724,1.073l9.28-4.647h.911Zm13.106-8.34a1.192,1.192,0,0,1-1.192,1.192H180.433a1.185,1.185,0,0,0-.532.119l-7.808,3.91V75.183a1.191,1.191,0,0,0-1.191-1.191H169.71a1.191,1.191,0,0,1-1.191-1.192V53.736a1.191,1.191,0,0,1,1.191-1.191h23.829a1.191,1.191,0,0,1,1.192,1.191Z",
    transform: "translate(-128.008 -20.375)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-19",
    "data-name": "Shape",
    d: "M228.643,105.221V107.6a3.574,3.574,0,0,0,3.574,3.575h6.288a2.375,2.375,0,0,0,2.052,1.191h2.383a2.383,2.383,0,0,0,2.383-2.383v-7.149a2.383,2.383,0,0,0-2.383-2.383h-2.383a2.365,2.365,0,0,0-1.773.807l-.715-2.86a3.575,3.575,0,0,0-6.937,1.733l.4,1.584A3.575,3.575,0,0,0,228.643,105.221Zm14.3-2.383v7.149h-2.383v-7.149Zm-11.915,2.383a1.192,1.192,0,0,1,1.192-1.191h.82a1.192,1.192,0,0,0,1.157-1.481l-.75-3a1.192,1.192,0,1,1,2.312-.578l1.039,4.154a1.191,1.191,0,0,0,1.156.9h.224V108.8h-5.957a1.192,1.192,0,0,1-1.192-1.191Z",
    transform: "translate(-183.367 -61.808)",
    fill: "#7821a0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_81",
    "data-name": "Grupo 81",
    transform: "translate(138.423 36.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_428",
    "data-name": "Trazado 428",
    d: "M151.157,60.5a3.183,3.183,0,0,1,.538-1.7,4.14,4.14,0,0,1,1.567-1.423,4.938,4.938,0,0,1,2.405-.564,5.131,5.131,0,0,1,2.255.471,3.659,3.659,0,0,1,1.511,1.281,3.145,3.145,0,0,1,.533,1.762,2.722,2.722,0,0,1-.3,1.313,4.014,4.014,0,0,1-.722.973q-.419.41-1.5,1.379a6.134,6.134,0,0,0-.48.48,1.934,1.934,0,0,0-.269.379,1.837,1.837,0,0,0-.137.343q-.048.172-.145.6a.981.981,0,0,1-1.048.916,1.072,1.072,0,0,1-.771-.3,1.178,1.178,0,0,1-.313-.89,3.122,3.122,0,0,1,.837-2.233,13.974,13.974,0,0,1,1.022-.974q.564-.493.815-.744a2.531,2.531,0,0,0,.423-.559,1.356,1.356,0,0,0,.171-.67,1.557,1.557,0,0,0-.524-1.189,1.914,1.914,0,0,0-1.352-.484,1.871,1.871,0,0,0-1.427.489,3.9,3.9,0,0,0-.775,1.44q-.3,1-1.136,1a1.116,1.116,0,0,1-.832-.348A1.063,1.063,0,0,1,151.157,60.5Zm4.3,9.655a1.385,1.385,0,0,1-.938-.348,1.22,1.22,0,0,1-.4-.974,1.255,1.255,0,0,1,.387-.934,1.309,1.309,0,0,1,.952-.379,1.293,1.293,0,0,1,1.312,1.312,1.23,1.23,0,0,1-.4.969A1.337,1.337,0,0,1,155.456,70.155Z",
    transform: "translate(-151.157 -56.818)",
    fill: "#7821a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_82",
    "data-name": "Grupo 82",
    transform: "translate(128.009 29.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_429",
    "data-name": "Trazado 429",
    d: "M141.116,67.673h3.293l9.281,4.647a1.192,1.192,0,0,0,1.724-1.072V67.673a3.574,3.574,0,0,0,3.575-3.575V45.036a3.573,3.573,0,0,0-3.134-3.545H134.907v-.03h-3.323a3.574,3.574,0,0,0-3.574,3.575,1.191,1.191,0,0,0,2.383,0,1.192,1.192,0,0,1,1.191-1.192h23.83a1.191,1.191,0,0,1,1.191,1.192V64.1a1.191,1.191,0,0,1-1.191,1.191h-1.191a1.192,1.192,0,0,0-1.192,1.192V69.32l-7.808-3.9a1.194,1.194,0,0,0-.533-.125H131.584a1.191,1.191,0,0,1-1.191-1.191V54.567a1.191,1.191,0,0,0-2.383,0V64.1a3.574,3.574,0,0,0,3.574,3.575h9.532Z",
    transform: "translate(-128.01 -41.461)",
    fill: "#7821a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_430",
    "data-name": "Trazado 430",
    d: "M240.158,86.463h-9.532v-.014h-2.383v.014H216.329a3.574,3.574,0,0,0-3.575,3.575V109.1a3.574,3.574,0,0,0,3.575,3.575v3.574a1.192,1.192,0,0,0,1.724,1.073l9.281-4.647h12.825a3.575,3.575,0,0,0,3.574-3.575V90.038A3.574,3.574,0,0,0,240.158,86.463ZM241.35,109.1a1.192,1.192,0,0,1-1.191,1.191H227.052a1.187,1.187,0,0,0-.533.119l-7.808,3.91v-2.838a1.192,1.192,0,0,0-1.192-1.191h-1.191a1.192,1.192,0,0,1-1.191-1.191V90.038a1.192,1.192,0,0,1,1.191-1.191h23.83a1.192,1.192,0,0,1,1.191,1.191Z",
    transform: "translate(-174.627 -66.209)",
    fill: "#7821a0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02IconoRecomendaciones);
export default __webpack_public_path__ + "static/media/02-icono-recomendaciones.ad07218cc3541e8a5d47a3ceda0c62d0.svg";
export { ForwardRef as ReactComponent };